import { Navigate } from "react-router-dom";
import SupplierTermsGate from "./SupplierTermsGate";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/login" />;
  }
  return <SupplierTermsGate>{children}</SupplierTermsGate>;
}

export default ProtectedRoute;
